import { Model } from "vue-mc";

export class PopEntryExit extends Model {
  defaults() {
    return {
      clave: null
      , descripcion: ""
      , tipo: ""
      , defaults: ""
      , multiple: true
      , status: true
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , descripcion: (descripcion) => descripcion
      , tipo: (tipo) => tipo
      , defaults: (defaults) => defaults
      , multiple: (multiple) => multiple
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/operativos/popEntryExit.js